import JSDB from '../../fromKotlin/nk';

const API_BASE = 'https://nihulkav.online:4000';

/**
 * תיקיית המדיה הנוכחית ב-S3: `data/_app/whats-new/<version>/`.
 * מעלים גרסה כשמחליפים סט תמונות/סרטונים.
 */
export const WHATS_NEW_MEDIA_VERSION = 'v1';

/** קבצים ב-`public/whats-new` — מוצגים מיד בלי העלאה ל-S3 */
const LOCAL_WHATS_NEW_FILES = new Set(['attendance-clock.webp']);

/**
 * URL לתמונה או לסרטון של דף "מה חדש". הקבצים מועלים ידנית דרך קונסולת AWS
 * לתיקייה של הגרסה, והדלי נשאר פרטי — השרת (`/app/whats_new/media`) שולף
 * מ-S3 ומזרים את הבייטים, כך שאין צורך בהרשאת public-read.
 *
 * מקבל שם קובץ בלבד: `whatsNewMediaUrl('ai-assistant.webp')`.
 * קבצים ב-`LOCAL_WHATS_NEW_FILES` נטענים מ-`public/whats-new`.
 */
export function whatsNewMediaUrl(fileName?: string, version: string = WHATS_NEW_MEDIA_VERSION): string {
    if (!fileName) return '';
    if (LOCAL_WHATS_NEW_FILES.has(fileName)) {
        return `${process.env.PUBLIC_URL || ''}/whats-new/${fileName}`;
    }
    const params = new URLSearchParams({
        file: fileName,
        version,
        jwt: JSDB().getToken(),
    });
    return `${API_BASE}/app/whats_new/media?${params.toString()}`;
}
